import React, { useState } from "react";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { signInWithPopup } from "firebase/auth";
import { auth, provider } from "../../../firebase";
import { hitLoginProfessionalApi } from "../../../Redux/Professional/LoginSlice";

import { hitSocialLoginProfessionalApi } from "../../../Redux/Professional/SocialLoginProfessionalSlice";
import { } from "../../../Redux/Client/LoginSlice";
import { hitSocialLoginClientApi } from "../../../Redux/Client/SocialLoginClientSlice";
import logo from "../../../assets/img/SimpleRenovate.svg";
import Loader from "../../Loader/Loader";
import google_icon from "../../../assets/img/devicon_google.svg";

const LoginScreen = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // simple regex
    return regex.test(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      let body = {};
      setLoading(true);
      // email login
      body = { email, password };
      if (!validateEmail(email)) {
        showToast("Please enter a valid email address.", "error");
        setLoading(false);
        return;
      }
      const res = await dispatch(hitLoginProfessionalApi(body));
      if (res.payload.status === true) {
        setLoading(false);
        showToast("Login Successful", "success");
        if (res.payload?.data) {
          localStorage.setItem(
            "mobileRedirectionProData",
            JSON.stringify(res.payload.data),
          );
          localStorage.setItem(
            "professionalTokenMobileRedirection",
            JSON.stringify(res.payload.data.accessToken),
          );
          navigation("/manage-dashboard");
          handleViewDetails();
        }
      } else {
        setLoading(false);
        showToast(res.payload.message, "error");
      }
    } catch (err) {
      setLoading(false);
    }
  };


  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      if (result) {
        setLoading(true);
        const user = result.user;
        let response = await dispatch(
          hitSocialLoginProfessionalApi({
            type: "Google",
            email: user.email,
            profileImage: user.photoURL,
            firstName: user.displayName,
            googleId: user.uid,
            isSignupFromMobileOrWeb: 2, // 1 for mobile, 2 for web
          }),
        );
        if (response.payload.status === true) {
          setLoading(false);

          localStorage.setItem(
            "professionalTokenMobileRedirection",
            response.payload.data.accessToken,
          );
          localStorage.setItem("professionalId", response.payload.data._id);
          localStorage.setItem(
            "mobileRedirectionProData",
            JSON.stringify(response.payload.data),
          );
          showToast("Login Successful", "success");
          navigation("/manage-dashboard");
          handleViewDetails();
        } else {
          setLoading(false);
          showToast(response.payload.message, "error");
        }
      }
      // Handle successful login here
    } catch (error) {
      // Handle login error here
    }
  };

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (loading) {
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }

  return (
    <div className="login-form">
      {/* Logo */}
      <div className="login-form__logo mb-2">
        <img src={logo} alt="Logo" />
      </div>

      <p className="login-form__subtitle">
        Welcome back! Please sign in to continue
      </p>

      <div className="login-form__card">
        {/* <button className="login-form__signup">Sign up as Professional</button> */}

        <h4>Welcome Back</h4>
        <p>Login with your account by using the form below</p>

        <form onSubmit={handleSubmit}>
          <label>Email Address *</label>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Password *</label>
          <div className="password-input">
            <input
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="login-btn"
            onClick={handleViewDetails}
          >
            Login
          </button>
        </form>
      </div>



      <div className="login-form__divider">Or sign up with</div>
      <div className="social-login social-login-signup">

        <div className="google_btn_" onClick={handleGoogleLogin}>
          <img src={google_icon} alt="google icon" />
          <p>Continue with Google</p>
        </div>
      </div>


    </div>
  );
};

export default LoginScreen;
